import http from './http.service';

class BookingService {
    constructor() {
        if (BookingService.instance) {
            return BookingService.instance;
        }

        BookingService.instance = this;
    }

    pickupsReturns(date) {
        return http.get('/booking/pickups-returns', { params: {date: date} }).then(res => res.data);
    }
    pastBookings(dates) {
        return http.get('/booking/past', { params: {start: dates[0], end: dates[1]} }).then(res => res.data);
    }
    futureBookings() {
        return http.get('/booking/future').then(res => res.data);
    }
    currentBookings() {
        return http.get('/booking/current').then(res => res.data);
    }
    presentBookings() {
        return http.get('/booking/present').then(res => res.data);
    }
    notConfirmed() {
        return http.get('/booking/not-confirmed').then(res => res.data);
    }
    booking(bookingId) {
        return http.get(`/booking/${bookingId}/show`).then(res => res.data);
    }
    sendEmails(bookingId) {
        return http.get(`/booking/${bookingId}/send-emails`).then(res => res.data);
    }
    store(data) {
        return http.post('/booking/store', data).then(res => res.data);
    }
    storeBookingComments(data) {
        return http.post('/booking/comments/store', data).then(res => res.data);
    }
    update(bookingId, data) {
        return http.put(`/booking/${bookingId}/update`, data).then(res => res.data);
    }
    toggleDone(bookingId, isReturn) {
        return http.put(`/booking/${bookingId}/toggle-done?is_return=${isReturn}`).then(res => res.data);
    }
    destroy(bookingId) {
        return http.delete(`/booking/${bookingId}/destroy`).then(res => res.data);
    }
    confirmBooking(bookingId) {
        return http.put(`/booking/${bookingId}/confirm`).then(res => res.data);
    }
}

export default new BookingService();
